export default __webpack_public_path__ + "static/media/edit-color.952450ad.svg";